// Utility function to reset zoom and pan for images
function resetZoom(modal) {
  const zoomImages = modal.querySelectorAll('.custom-zoom-image');
  zoomImages.forEach((zoomImage) => {
    zoomImage.style.transform = 'scale(1) translate(0, 0)';
  });
}

// Utility function to calculate focusable elements
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Trap focus functionality
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// ModalDialog class
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    document.querySelector('body').addEventListener('click',(e) =>{
      if(e.target.matches('[data-zoom-add-to-cart]')){
        document.querySelector('[data-add-to-cart]').click();
      }
    });
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model') && !event.target.classList.contains('.productForm-submit')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;

    console.log('Opened by', this.openedBy);
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();

    if(window.innerWidth < 992){
      let zoomContainers = document.querySelectorAll('.custom-zoom-container');
      let translateX = 0;
      let translateY = 0;
      zoomContainers.forEach((zoomContainer) =>{
        let zoomImages = zoomContainer.querySelectorAll('.custom-zoom-image');
        let scale = 1.2;
        const containerRect = zoomContainer.getBoundingClientRect();
        const imageRect = zoomImages[0].getBoundingClientRect();

        const maxTranslateX = Math.max((imageRect.width * scale - containerRect.width) / 2, 0);
        const maxTranslateY = Math.max((imageRect.height * scale - containerRect.height) / 2, 0);

        translateX = Math.min(Math.max(translateX, -maxTranslateX), maxTranslateX);
        translateY = Math.min(Math.max(translateY, -maxTranslateY), maxTranslateY);

        // Apply zoom and pan to all images
        zoomImages.forEach((zoomImage) => {
          zoomImage.style.transform = `scale(${scale}) translate(${translateX / scale}px, ${translateY / scale}px)`;
        });
      })
      
    }

    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    console.log('thissss',this);
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');

    // Reset zoom when the modal is closed
    resetZoom(this);

    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

// ProductModal class
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

        console.log('activeMedia', activeMedia);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

// ModalOpener class
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);




// // Zoom Functionality
// const zoomContainers = document.querySelectorAll('.custom-zoom-container');

// zoomContainers.forEach((zoomContainer) => {
//   const zoomImages = zoomContainer.querySelectorAll('.custom-zoom-image'); // Select all images in the container
//   let scale = 1;
//   let initialDistance = 0;
//   let currentScale = 1;
//   let panX = 0;
//   let panY = 0;
//   let startX = 0;
//   let startY = 0;

//   zoomContainer.addEventListener('touchstart', (e) => {
//     if (e.touches.length === 2) {
//       // Calculate the initial distance between fingers
//       initialDistance = getDistance(e.touches[0], e.touches[1]);
//       currentScale = scale;
//     } else if (e.touches.length === 1) {
//       // Save the initial touch position for panning
//       startX = e.touches[0].clientX - panX;
//       startY = e.touches[0].clientY - panY;
//     }
//   });

//   zoomContainer.addEventListener('touchmove', (e) => {
//     if (e.touches.length === 2) {
//       e.preventDefault(); // Prevent scrolling during pinch
//       // Calculate the current distance and scale
//       const currentDistance = getDistance(e.touches[0], e.touches[1]);
//       scale = currentScale * (currentDistance / initialDistance);

//       // Limit the scale
//       scale = Math.min(Math.max(scale, 1), 3); // Min 1x, Max 3x zoom

//       // Apply the zoom transform to all images
//       applyTransform();
//     } else if (e.touches.length === 1 && scale > 1) {
//       e.preventDefault(); // Prevent scrolling during panning
//       // Calculate the pan offset
//       panX = e.touches[0].clientX - startX;
//       panY = e.touches[0].clientY - startY;

//       // Apply the pan transform to all images
//       applyTransform();
//     }
//   });

//   zoomContainer.addEventListener('touchend', () => {
//     // Reset scale and pan if necessary
//     if (scale < 1) {
//       scale = 1;
//       panX = 0;
//       panY = 0;
//       applyTransform();
//     }
//   });

//   // Apply the transform (zoom and pan) to all images
//   function applyTransform() {
//     zoomImages.forEach((zoomImage) => {
//       zoomImage.style.transform = `scale(${scale}) translate(${panX / scale}px, ${panY / scale}px)`;
//     });
//   }

//   // Utility function to calculate the distance between two touches
//   function getDistance(touch1, touch2) {
//     const deltaX = touch2.clientX - touch1.clientX;
//     const deltaY = touch2.clientY - touch1.clientY;
//     return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//   }
// });



const zoomContainers = document.querySelectorAll('.custom-zoom-container');

zoomContainers.forEach((zoomContainer) => {
  const zoomImages = zoomContainer.querySelectorAll('.custom-zoom-image'); // Select all images in the container
  let scale = 1;
  let currentScale = 1;
  let startX = 0;
  let startY = 0;
  let translateX = 0;
  let translateY = 0;
  let lastTranslateX = 0;
  let lastTranslateY = 0;

  zoomContainer.addEventListener('touchstart', (e) => {
    if (e.touches.length === 2) {
      // Pinch start: Save initial scale
      const distance = getDistance(e.touches[0], e.touches[1]);
      zoomContainer.dataset.initialDistance = distance;
      currentScale = scale;
    } else if (e.touches.length === 1) {
      // Single touch: Start panning
      startX = e.touches[0].clientX - lastTranslateX;
      startY = e.touches[0].clientY - lastTranslateY;
    }
  });

  zoomContainer.addEventListener('touchmove', (e) => {
    if (e.touches.length === 2) {
      e.preventDefault(); // Prevent scrolling during pinch
      const initialDistance = parseFloat(zoomContainer.dataset.initialDistance);
      const currentDistance = getDistance(e.touches[0], e.touches[1]);
      scale = currentScale * (currentDistance / initialDistance);
      scale = Math.min(Math.max(scale, 1), 3); // Clamp scale between 1x and 3x

      applyZoom();
    } else if (e.touches.length === 1 && scale > 1) {
      e.preventDefault(); // Prevent scrolling during pan
      translateX = e.touches[0].clientX - startX;
      translateY = e.touches[0].clientY - startY;

      applyZoom();
    }
  });

  zoomContainer.addEventListener('touchend', () => {
    // Save the current pan position
    lastTranslateX = translateX;
    lastTranslateY = translateY;
  });

  function applyZoom() {
    // Enforce boundaries for panning
    const containerRect = zoomContainer.getBoundingClientRect();
    const imageRect = zoomImages[0].getBoundingClientRect();

    const maxTranslateX = Math.max((imageRect.width * scale - containerRect.width) / 2, 0);
    const maxTranslateY = Math.max((imageRect.height * scale - containerRect.height) / 2, 0);

    translateX = Math.min(Math.max(translateX, -maxTranslateX), maxTranslateX);
    translateY = Math.min(Math.max(translateY, -maxTranslateY), maxTranslateY);

    // Apply zoom and pan to all images
    zoomImages.forEach((zoomImage) => {
      zoomImage.style.transform = `scale(${scale}) translate(${translateX / scale}px, ${translateY / scale}px)`;
    });
  }

  // Utility function to calculate the distance between two touches
  function getDistance(touch1, touch2) {
    const deltaX = touch2.clientX - touch1.clientX;
    const deltaY = touch2.clientY - touch1.clientY;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  }
});

